module.exports = __webpack_public_path__ + "static/img/bg-item1.2de5fd91.png";